var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootersocialicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6395 14.4674L31.9245 0.494141H29.0133L18.3463 12.6269L9.82652 0.494141H0L12.8835 18.841L0 33.4941H2.91132L14.176 20.6815L23.1735 33.4941H33L19.6388 14.4674H19.6395ZM15.652 19.0027L14.3467 17.1757L3.9603 2.6386H8.43191L16.8138 14.3705L18.1192 16.1975L29.0147 31.4472H24.5431L15.652 19.0034V19.0027Z",
    fill: "url(#paint0_linear_2640_10925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2640_10925",
    x1: 16.5,
    y1: 0.494141,
    x2: 16.5,
    y2: 33.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootersocialicon);
export default __webpack_public_path__ + "static/media/footer social icon.053d4f274c60e5147500f3aa37ce8c49.svg";
export { ForwardRef as ReactComponent };